
import { DesignerResource } from '@/models/api/resource/DesignerResource'
import BreadcrumbItem from '@/models/BreadcrumbItem'
import { NamedRoute, RouteName } from '@/router'
import { defineAsyncComponent, defineComponent } from 'vue'

export default defineComponent({
    name: 'DesignerProfile',
    components: {
        AppBreadcrumb: defineAsyncComponent(() => import('@/components/AppBreadcrumb.vue')),
        DesignerAvatar: defineAsyncComponent(() => import('@/components/DesignerAvatar.vue')),
        DesignerBanner: defineAsyncComponent(() => import('@/components/DesignerBanner.vue')),
        DesignerCover: defineAsyncComponent(() => import('@/components/DesignerCover.vue')),
        DesignerHeadline: defineAsyncComponent(() => import('@/components/DesignerHeadline.vue')),
        DesignerInformation: defineAsyncComponent(() => import('@/components/DesignerInformation.vue')),
        DesignerShowcase: defineAsyncComponent(() => import('@/components/DesignerShowcase.vue')),
        GetStartedBanner: defineAsyncComponent(() => import('@/components/GetStartedBanner.vue')),
        StarRating: defineAsyncComponent(() => import('@/components/StarRating.vue')),
    },
    computed: {
        designer(): DesignerResource {
            return this.$store.getters['designer']
        },
        breadcrumbItems(): BreadcrumbItem[] {
            return [
                new BreadcrumbItem('Our Designers', new NamedRoute(RouteName.DESIGNERS)),
                this.designer ? new BreadcrumbItem(this.designer.fullName) : null,
            ].filter(Boolean)
        },
    },
    async created(): Promise<void> {
        try {
            await this.$store.dispatch('loadDesigner')
        }
        catch (err: any) {
            await this.$router.push({ name: RouteName.DESIGNERS })
        }
    },
})
